// extracted by mini-css-extract-plugin
export default {"container":"Cs9YCI","originalContainer":"lZTyg8","component":"g_eZo1"};